export default {
  'global.average': 'Global Avg.',
  'contact.email': 'bizdev@delta.app',
  'coming.soon': 'Coming Soon',
  'image.upload': 'Drag or upload an image',
  'image.remove': 'Remove image',
  'button.new': '+ New Post',
  'button.post': 'Post',
  'button.modify': 'Modify',
  'button.delete': 'Delete',
  'button.cancel': 'Cancel',
  'button.contact': 'Contact Us',
};
